import { apiSlice } from "../api/apiSlice";

export const assignmentMarkAPI = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentMarks: builder.query({
      query: () => "/assignmentMark",
    }),
    getAssignmentMarkOfStudent: builder.query({
      query: ({ student_id, assignment_id }) =>
        `/assignmentMark?assignment_id=${assignment_id}&student_id=${student_id}`,
      providesTags: ["assignmentMarkOfStudent"],
    }),

    addAssignmentMark: builder.mutation({
      query: (data) => ({
        url: "/assignmentMark",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["assignmentMarkOfStudent"],

      async onQueryStarted(data, { queryFulfilled, dispatch }) {
        try {
          const addResult = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignmentMarks",
              undefined,
              (draft) => {
                draft.push(addResult.data);
              }
            )
          );
        } catch (error) {
          console.error("Something Went Wrong!");
          console.error(error);
        }
      },
    }),
    editAssignmentMark: builder.mutation({
      query: ({ id, data }) => ({
        url: `/assignmentMark/${id}`,
        method: "PATCH",
        body: data,
      }),

      async onQueryStarted({ id, data }, { queryFulfilled, dispatch }) {
        const editResult = dispatch(
          apiSlice.util.updateQueryData(
            "getAssignmentMarks",
            undefined,
            (draft) => {
              const targetIndex = draft.findIndex(
                (assignment) => assignment.id === Number(id)
              );
              let target = draft[targetIndex];
              target = { ...target, ...data };
              draft[targetIndex] = target;
            }
          )
        );

        try {
          const result = await queryFulfilled;
          if (result.meta.response.status === 200) {
            console.log("Successfully Updated!");
          }
        } catch (error) {
          editResult.undo();
          console.log(error);
        }
      },
      // async onQueryStarted(arg, { queryFulfilled, dispatch }) {
      //   try {
      //     const editResult = await queryFulfilled;

      //     //Update Tasks Cache
      //     // await dispatch(
      //     //   apiSlice.util.updateQueryData(
      //     //     "getAssignments",
      //     //     undefined,
      //     //     (draft) => {
      //     //       let target = draft.findIndex(
      //     //         (assignment) => Number(assignment.id) === arg.id
      //     //       );
      //     //       draft[target] = editResult.data;
      //     //     }
      //     //   )
      //     // );

      //     //Update Task Cache for edit
      //     const id = String(arg.id);
      //     await dispatch(
      //       apiSlice.util.updateQueryData("getAssignment", id, (draft) => {
      //         draft.title = editResult.data.title;
      //         draft.video_id = editResult.data.video_id;
      //         draft.video_title = editResult.data.video_title;
      //         draft.totalMark = editResult.data.totalMark;
      //       })
      //     );
      //   } catch (error) {
      //     console.error("Something went Wrong!");
      //   }
      // },
    }),
  }),
});

export const {
  useGetAssignmentMarksQuery,
  useGetAssignmentMarkOfStudentQuery,
  useAddAssignmentMarkMutation,
  useEditAssignmentMarkMutation,
} = assignmentMarkAPI;
